// REACT
import { useState } from 'react';

// YARN
import { ThemeProvider } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { toast } from 'react-toastify';

// SERVICES
import { deleteCultureGroup } from 'services/API/Cooperative';
import { displayErrorMessage } from 'utils/tools_functions';

// INTERFACES
import { ICultureGroup } from 'components/generics/Interface/ICultureGroup';

// THEMES
import { customDialogTheme } from 'assets/styles/themes/Dialog/generic_dialog_mui';

const useCultureGroupAction = (
  ownerId: number,
  cultureGroup: ICultureGroup[],
  refreshData: Function,
  setModal: Function,
  setEditData: Function
) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [actionId, setActionId] = useState<number | null>(null);

  const handleDeleteDialogOpen = async (id: number) => {
    setActionId(id);
    setOpenDeleteDialog(true);
  };

  const handleEditDialogOpen = async (id: number) => {
    setActionId(id);
    updateCultureGroupFromAction(id);
    setModal(true);
  };

  const updateCultureGroupFromAction = (groupId: number) => {
    const cultureGroupToUpdate = cultureGroup?.find((group) => group?.id === groupId);

    setEditData(cultureGroupToUpdate);
  };

  const handleDeleteClick = async () => {
    setOpenDeleteDialog(false);
    const cultureGroupToDelete = cultureGroup.find((group) => group.id === actionId);
    try {
      await deleteCultureGroup(ownerId, cultureGroupToDelete?.id);
      toast.success(`Groupe de culture ${cultureGroupToDelete?.name} supprimé`);
      refreshData();
    } catch (error) {
      toast.error(displayErrorMessage('ERR_DELETE_CULTURE_GROUP'));
    }
  };

  const renderDeleteDialog = () => {
    return (
      <ThemeProvider theme={customDialogTheme}>
        <Dialog maxWidth="xs" open={openDeleteDialog}>
          <DialogTitle>Attention</DialogTitle>
          <DialogContent dividers>
            {`Voulez-vous vraiment supprimer`} <br /> {`ce groupe de culture ?`}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteClick}>
              Oui <DoneIcon />
            </Button>
            <Button onClick={() => setOpenDeleteDialog(false)}>
              Non <ClearIcon />
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  return {
    renderDeleteDialog,
    handleDeleteDialogOpen,
    handleEditDialogOpen,
  };
};

export default useCultureGroupAction;
